import {IMGPW} from '@/config';
import Image from 'next/image';
import {Button} from '../../../../components/design-system';

const SectionFormats = () => {
  function scrollDown(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  }

  return (
    <div className="container">
      <h3 className="tw-font-bold tw-text-4xl tw-mb-8 tw-scroll-mt-20 tw-tracking-tighter tw-text-gray-800">
        <span>Drei verschiedene Formate</span>
        <span className="tw-text-secondary"> anpassbar an </span>
        <span className="">alle Quadrate</span>
      </h3>

      <div className="tw-space-y-12">
        <div className="tw-flex tw-items-center tw-flex-col tw-gap-8 md:tw-gap-12 md:tw-flex-row">
          <div className="tw-flex-1 tw-w-full tw-h-96 position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/bar_enoteca.jpg`}
              alt="Bar & enoteca"
            />
          </div>
          <div className="tw-flex-1">
            <h5 className="tw-text-4xl tw-font-bold tw-tracking-tighter tw-text-primary tw-pb-2 tw-underline">
              Bar und Weinhandlung
            </h5>
            <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight">
              In der Bar können die Kunden direkt aus der App Flaschen auswählen, kaufen und
              und Informationen zu den Flaschen direkt aus der App abrufen.
            <br />
              Die App führt den Kunden durch die Auswahl mittels eines{' '}
            <strong>virtuellen Sommelier</strong>. In der App selbst ist ein
              Treueprogramm integriert.
            <br />
              Das Format eignet sich besonders für stark frequentierte Bereiche und
              die bereits andere kommerzielle Marken haben.
            </div>
            <h6 className="tw-pt-5 tw-text-xl tw-mb-0 tw-font-bold tw-tracking-tighter tw-text-gray-600">
              Highlights:
            </h6>
            <ul className="tw-py-2 tw-list-disc tw-font-medium tw-tracking-tight">
              <li className="!tw-text-base md:!tw-text-lg">Mindestens 35 Quadratmeter</li>
              <li className="!tw-text-base md:!tw-text-lg">
                Durchgangsstraße auch ohne Schornstein
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Eintrittspreis: 8.900€;
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                5% Tantieme auf den Umsatz
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Einrichtungskosten: ca. 990 €/qm (Bezugsraum 50qm)
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Bruttobetriebsspanne: 22%-30%.
              </li>
            </ul>
            <Button theme="outline" onClick={() => scrollDown('affiliazione')}>
              Ich bin interessiert an
            </Button>
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-flex-col tw-gap-8 md:tw-gap-12 md:tw-flex-row-reverse">
          <div className="tw-flex-1 tw-w-full tw-h-96 position-relative">
            <Image
              fill
              style={{objectFit: 'contain'}}
              src={`${IMGPW}/enoteca.jpg`}
              alt="Enoteca con delivery"
            />
          </div>
          <div className="tw-flex-1">
            <h5 className="tw-text-4xl tw-font-bold tw-tracking-tighter tw-text-primary tw-pb-2 tw-underline">
              Weinhandlung mit Lieferung
            </h5>
            <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight">
              Vor Ort kann der Kunde die Flaschen auswählen, kaufen und
              und Informationen über die Flaschen direkt in der App abrufen. Der
              Ort ist auch die Basis für die Lieferung nach Hause.
            <br />
              Die App führt den Kunden durch die Auswahl mittels eines{' '}
            <strong>virtuellen Sommelier</strong>. In der App selbst ist ein
              Treueprogramm integriert.
            <br />
              Das Format eignet sich besonders für stark frequentierte Bereiche und
              die bereits andere kommerzielle Marken haben.
            </div>
            <h6 className="tw-pt-5 tw-text-xl tw-mb-0 tw-font-bold tw-tracking-tighter tw-text-gray-600">
              Highlights:
            </h6>
            <ul className="tw-py-2 tw-list-disc tw-font-medium tw-tracking-tight">
              <li className="!tw-text-base md:!tw-text-lg">Mindestens 75 Quadratmeter</li>
              <li className="!tw-text-base md:!tw-text-lg">
                Durchgangsstraße
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Eintrittspreis € 4.900
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                4% Tantieme auf den Umsatz
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Einrichtungskosten ca. 350 €/qm (Bezugsraum 75 qm)
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Bruttobetriebsspanne: 16%-24%.
              </li>
            </ul>
            <Button theme="outline" onClick={() => scrollDown('affiliazione')}>
              Ich bin interessiert an
            </Button>
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-flex-col tw-gap-8 md:tw-gap-12 md:tw-flex-row">
          <div className="tw-flex-1">
            <div className="tw-flex-1 tw-w-full tw-h-96 position-relative">
              <Image
                fill
                style={{objectFit: 'contain'}}
                src={`${IMGPW}/pimp_my_store.png`}
                alt="Pimp my store"
              />
            </div>
          </div>
          <div className="tw-flex-1">
            <h5 className="tw-text-4xl tw-font-bold tw-tracking-tighter tw-text-primary tw-pb-2 tw-underline">
              Meinen Laden aufpeppen
            </h5>
            <div className="tw-text-base md:tw-text-lg tw-font-medium tw-tracking-tight">
              Wenn Sie bereits eine Bar oder ein Weingeschäft haben, es aber aufpeppen möchten, können Sie eine Ecke einrichten, die dem Thema{' '}
            <strong>aufpeppen</strong> möchten, können Sie eine Ecke einrichten, die der
              Winelivery in Ihren Räumlichkeiten einrichten: ein 'Winelivery Point'
            <strong>maßgeschneidert für Sie</strong>. Pimp my store ist in der Tat
              eine "Ad-hoc"-Vereinbarung, die auf Ihre Bedürfnisse zugeschnitten ist und durch die
              durch die Sie die Möglichkeit haben:
            </div>
            <ul className="tw-py-2 tw-list-disc tw-font-medium tw-tracking-tight">
              <li className="!tw-text-base md:!tw-text-lg">
                Ihre Einkaufsbedingungen zu verbessern dank des Zugangs zum
                Winelivery-Einkaufszentrum, mit exklusiven Produkten und
                subventionierten Preisen;
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Einfügen unverwechselbarer Winelivery-Elemente o{' '}
              <strong>Erneuern</strong> Sie das Layout Ihrer
                Bar/Weinbar;
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Implementierung der Winelivery-Technologie in Ihrer Bar/Weinbar,
                mit der Möglichkeit der Hauszustellung ausschließlich in Ihrem
                Gebiet.
              </li>
              <li className="!tw-text-base md:!tw-text-lg">
                Es gibt keine Einstiegsgebühr und Sie können mit Ihrem
                aktuellen Kassengerät arbeiten.
              </li>
            </ul>
            <Button theme="outline" onClick={() => scrollDown('affiliazione')}>
              Ich bin interessiert an
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionFormats;
